import React, { useEffect, useRef } from 'react';
import History from './History';
import Footer from 'components/Footer';

const CORE_VALUES = [
  {
    image: 'images/about_vision_white_transparent.png',
    alt: 'vision',
    title: 'Vision',
    point: 'V',
    className: 'icon1',
    desc: '각 사업분야에서 핵심요소로 적용되어 고객에게 최고의 가치를 제공',
  },
  {
    image: 'images/about_passion_white_transparent.png',
    alt: 'passion',
    title: 'Passion',
    point: 'P',
    className: 'icon2',
    desc: '차별화 된 IT Consulting을 제공 다양한 Business Application 전달',
  },
  {
    image: 'images/about_role_white_transparent.png',
    alt: 'role',
    title: 'Role',
    point: 'R',
    className: 'icon3',
    desc: '끊임없는 기술개발과 창조적인 사고, 시장을 주도하는 역할을 수행',
  },
  {
    image: 'images/about_technique_white_transparent.png',
    alt: 'technique',
    title: 'Technique',
    point: 'T',
    className: 'icon4',
    desc: '국내 최고의 솔루션과 서비스를 위해 신기술 개발 및 탄탄한 기술력 유지',
  },
];

function About() {
  const refs = useRef([]);

  useEffect(() => {
    const targets = refs.current.filter(Boolean);

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion) {
      targets.forEach((target) => target.classList.add('visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.28,
      }
    );

    targets.forEach((target) => observer.observe(target));

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div className="about_first">
        <div ref={(el) => (refs.current[0] = el)}>
          <strong className="about_core_title">ABOUT US</strong>
          
          <span className="sub_span about">
            <br />
            모든 임직원의 창조적 열정을 응원하고<br />
            다양한 배움의 기회를 제공하는 신뢰 받는 기업
          </span>
        </div>
      </div>

      <div className="front_wrap about" ref={(el) => (refs.current[1] = el)}>
        <img
          src="images/com_introduce.png"
          className="front_main_img"
          alt="이케이시스 메인 이미지"
        />

        <div className="about_intro">
          <span className="about_span">
            이케이시스는 기업의 다양한 업무환경에 적합한 소프트웨어 맞춤 컨설팅을 통해서 고객사의 업무 효율성을 높이고 더 나은 업무환경 구축을 위한 최적의 솔루션을 제공합니다.빠르게 변화하는 IT아웃소싱 환경에 클라이언트, 파트너스 모두가 안전하게 프로젝트를 진행할 수 있도록 시스템을 개발하고 문제점을 개선하기 위해 노력하고 있습니다.
          </span>

          <div className="sign">
            이케이시스 대표 <img src="images/com_signature.png" alt="대표 서명" />
          </div>
        </div>
      </div>

      <div className="--scroll-down" />

      <div className="about_div" ref={(el) => (refs.current[2] = el)}>
        <div className="about_head_intro" ref={(el) => (refs.current[3] = el)}>
          <strong className="about_core_title">CORE VALUES</strong>
          <span>
            탁월한 IT 기술 인력과 축적된 기술력을 바탕으로<br />
            고객에게 최고의 서비스를 제공합니다
          </span>
        </div>

        <div className="about_head" ref={(el) => (refs.current[4] = el)}>
          {CORE_VALUES.map((item) => (
            <div className="vision_con" key={item.title}>
              <div className="about_value_icon">
                <img src={item.image} alt={item.alt} />
              </div>

              <h2>
                <span className={item.className}>{item.point}</span>
                {item.title.slice(1)}
              </h2>

              <span>{item.desc}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="padding_div" />

      <History ref={(el) => (refs.current[5] = el)} />

      <div className="padding_div" />
      <Footer />
    </>
  );
}

export default About;